import { Children, isValidElement, type ReactNode } from 'react';

export const findChildIndexByProp = (
  children: ReactNode,
  propName: string,
  propValue: any,
): number =>
  Children.toArray(children).findIndex(el => {
    if (!isValidElement(el)) return false;
    return (el.props as Record<string, unknown>)[propName] === propValue;
  });
